// extracted by mini-css-extract-plugin
export default {"container":"Products_container__kJp0n","products":"Products_products__FUOua","menu":"Products_menu__QDiqG","list":"Products_list__blIix","product":"Products_product__0EfUH"};